import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { CONTACT, OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function PressPage() {
  return (
    <LegalLayout title="Press & brand" subtitle="Media inquiries and assets.">
      <LegalSection title="Press contact">
        <LegalP>
          <a href={`mailto:${CONTACT.admin}`} className={tw.link}>
            {CONTACT.admin}
          </a>
          <br />
          {OPERATOR.name}
          <br />
          {CONTACT.phones[0]}
        </LegalP>
      </LegalSection>

      <LegalSection title="About in one line">
        <LegalP>
          <strong>{OPERATOR.product}</strong> — India-first photo and short-video social with
          contact-based discovery, Parallel collab, and creator tips.
        </LegalP>
      </LegalSection>

      <LegalSection title="Product facts">
        <LegalUl
          items={[
            "Platforms: Android (primary), web companion at daywia.com.",
            "Content types: Frames (photos), Drifts (short video), Parallel (dual capture).",
            "Monetization: direct INR tips, subscriptions & unlocks (Cashfree), AdMob on free tiers.",
            "Languages: English plus regional packs in the Android app.",
            "Operator: Kodavatikanti Niranjan, Kadapa, Andhra Pradesh, India.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Brand usage">
        <LegalP>
          Do not use the {OPERATOR.product} name or logo to imply endorsement without written
          permission. Request brand guidelines via {CONTACT.admin}.
        </LegalP>
      </LegalSection>

      <LegalSection title="More">
        <LegalP>
          <Link to="/about" className={tw.link}>
            About
          </Link>
          {" · "}
          <Link to="/legal" className={tw.link}>
            Legal
          </Link>
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
